import fetch from "@lib/fetch";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";

import type { FileUploadResponse } from "./types";

export const uploadFiles = reactQueryMutationAdapter(
  cacheKey,
  async (body: FormData): Promise<FileUploadResponse> => {
    return await fetch("/apps/upload_file", "POST", {}, { body }, { setContentType: false });
  }
);
